import { useEffect, useState } from "react"
import BallButton from "@/components/buttons/ball-button"
import useIsMobile from "@/hooks/use-is-mobile"
import { langStore } from "@/stores/lang-store"
import { reportStore } from "@/routes/apt/[apt_code]/report/report-store"
import { barChartStore } from "../../bar-chart/bar-chart-store"
import { boxplotHorizontalStore } from "../../boxplot/boxplot-horizontal-store"
import { boxplotVerticalStore } from "../../boxplot/boxplot-vertical-store"
import { summaryStore } from "../summary-store"
import { controllerBundle } from "./controller-const"

const LegendController = () => {
  const { lang } = langStore()
  const isMobile = useIsMobile()

  const [isOpen, setIsOpen] = useState(false)

  const { summary, allUnitUsages, groupStats, customColors } = reportStore()
  const { selectedKey, setSelectedKey, setPageIdx } = summaryStore()

  const allLabel = controllerBundle.all[lang]

  const legends = [
    {
      key: "ALL",
      label: allLabel,
      color: "pink"
    },
    ...Object.entries(customColors).map(([aptSize, color]) => ({
      key: aptSize,
      label: aptSize,
      color
    }))
  ]

  const changeLegend = (key) => {
    if (key === selectedKey) {
      setIsOpen(false)
      return
    }

    setSelectedKey(key)

    if (isMobile) {
      setPageIdx(0)
      setIsOpen(false)
    }

    if (key === "ALL") {
      barChartStore.getState().setChart(allLabel, allUnitUsages, customColors)

      const allBoxplot = {
        apt_size: key,
        boxplot: summary.boxplot,
        outliers: summary.outliers
      }

      boxplotVerticalStore.getState().setChart(key, allBoxplot, customColors)

      boxplotHorizontalStore.getState().setChart(key, allBoxplot, customColors)

      return
    }

    const selected = groupStats.find((group) => group.apt_size === key)

    if (!selected) return

    const boxplot = {
      apt_size: key,
      boxplot: selected.boxplot,
      outliers: selected.outliers
    }

    boxplotVerticalStore.getState().setChart(key, boxplot, customColors)

    boxplotHorizontalStore.getState().setChart(key, boxplot, customColors)

    barChartStore.getState().setChart(key, selected.units, customColors)
  }

  useEffect(() => {
    return () => {
      setIsOpen(false)
    }
  }, [isMobile])

  return (
    <div
      className={`sticky top-0 md:static md:flex gap-4 md:mx-4 ${
        isOpen ? "bg-white shadow-md rounded-sm space-y-2 p-4" : ""
      }`}
    >
      {isMobile && !isOpen && (
        <button
          type="button"
          onClick={() => setIsOpen(true)}
          className="grid grid-cols-2 gap-2 shadow-md p-2 aspect-square rounded-sm border border-gray-200 bg-white"
        >
          {legends.slice(0, 4).map((legend) => (
            <span
              key={legend.key}
              style={{ backgroundColor: legend.color }}
              className="w-2 h-2 rounded-full"
            />
          ))}
        </button>
      )}

      {(!isMobile || isOpen) &&
        legends.map((legend) => (
          <BallButton
            key={legend.key}
            ballColor={legend.color}
            isActive={selectedKey === legend.key}
            onClick={() => changeLegend(legend.key)}
          >
            {legend.label}
          </BallButton>
        ))}
    </div>
  )
}

export default LegendController
